import React from "react";
import { StatusTags, TableAdv } from "../../../../../../components";
import { mapTableRows } from "../../../../../../utils";

const CallScheduleList = () => {
  const columns = [
    {
      key: "candidateName",
      label: "Candidate Name",
      columnMenu: false,
    },
    {
      key: "role",
      label: "Role",
      columnMenu: false,
    },
    {
      key: "date",
      label: "Date",
      columnMenu: false,
    },
    {
      key: "time",
      label: "Time",
      columnMenu: false,
    },
    {
      key: "status",
      label: "Status",
      columnMenu: false,
      render: (row) => <StatusTags tag={row.status} />,
    },
  ];

  const rows = Array.from({ length: 10 }, (_, i) => ({
    candidateName: "Ershad",
    role: "Frontend Developer",
    date: "05 Mar 2026",
    time: "10:30 AM",
    status: "Call Scheduled",
    
  }));

  const mappedRows = mapTableRows(rows, columns);
  return (
    <div className="flex flex-col mt-5 overflow-auto">
      <div className="flex flex-grow overflow-auto gap-4 mx-0.5">
        <TableAdv
          showSlNo
          columns={columns}
          rows={mappedRows}
          toolbarRight={{
            search: true,
            filter: true,

            fullScreen: true,
          }}
        />
      </div>
    </div>
  );
};

export default CallScheduleList;
